module.exports = __webpack_public_path__ + "img/4.1a28af1f.png";